import { render, staticRenderFns } from "./DatabaseConnectionShow.vue?vue&type=template&id=41df81a1"
import script from "./DatabaseConnectionShow.vue?vue&type=script&lang=js"
export * from "./DatabaseConnectionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports